import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ensureCodeTimerIsActive} from "../../Redux/Thunks/loginThunks";
import {SET_PHONE_NUMBER, SET_TITLE} from "../../Redux/Actions";

import {PhoneNumberForm} from "./PhoneNumberForm";
import {VerificationCodeForm} from "./VerificationCodeForm";

export const VerificationComponent = (props) => {
    const {displayPhoneNumberForm} = useSelector(state => state.loginState);
    const user = useSelector(state => state.userState.user);
    const dispatch = useDispatch();

    useEffect(() => {
        const maskedNumber = user?.maskedNumber;

        if (maskedNumber) {
            dispatch({type: SET_PHONE_NUMBER, maskedNumber});
            dispatch(ensureCodeTimerIsActive());
        } else {
            dispatch({type: SET_TITLE, title: 'Set up Two-Factor Authentication'});
        }
    }, []);

    return (
        <Fragment>
            {
                displayPhoneNumberForm ?
                    <PhoneNumberForm HideButtons={props.HideButtons} /> :
                    <VerificationCodeForm
                        HideButtons={props.HideButtons}
                    />
            }
        </Fragment>
    );
};

